import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import CellBase from './CellBase';
import RetinaImage from '../RetinaImage';
import TextLabel from '../Widgets/Labels/TextLabel';
import AttachmentGray from './images/attachments-gray.png';

export default class AttachmentCell extends CellBase {
    static displayName = displayName('TableView/AttachmentCell');

    static propTypes = {
        ...CellBase.propTypes,
        count: PropTypes.number.isRequired,
    };

    static contextTypes = CellBase.contextTypes;

    static defaultProps = {
        ...CellBase.defaultProps,
        cellType: 'attachment',
    };

    renderCell() {
        const { count } = this.props;
        const hasCount = count > 0;

        return hasCount && (
            <TextLabel>
                <RetinaImage image={AttachmentGray} />
                {` (${count})`}
            </TextLabel>
        );
    }
}
